import { ReactElement } from 'react';
import styles from './FVSStep11AlertContent.module.scss';

const FVSStep11AlertContent = (): ReactElement => (
  <div>
    <span className={styles.bold}>Please note:</span>
    {` If any of the fines are on a payment plan with an enforcement agency (eg. Victoria Police, Public Transport Victoria), you
    should contact them directly to cancel the plan – if the fineholder pays the fine in full we cannot consider it in the application.`}
  </div>
);

export default FVSStep11AlertContent;
